import * as actionTypes from '../Global_action.types';

const initialState = {
  loggingIn: false,
  clients: [],
  error: null,
  message: '',
};
const clientReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPLOAD_CLIENT_MASTER_REQUEST:
    case actionTypes.GET_CLIENTS_REQUEST:
    case actionTypes.UPDATE_CLIENT_REQUEST:
    case actionTypes.DELETE_CLIENT_REQUEST:
    case actionTypes.MULTIDELETE_UNIT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.UPLOAD_CLIENT_MASTER_SUCCESS:
    case actionTypes.UPDATE_CLIENT_SUCCESS:
    case actionTypes.DELETE_CLIENT_SUCCESS:
    case actionTypes.MULTIDELETE_UNIT_SUCCESS:
      return {
        ...state,
        loading: false,
        clients: action.payload,
      };
    case actionTypes.GET_CLIENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        clients: action.payload,

      }

    case actionTypes.UPLOAD_CLIENT_MASTER_FAILURE:
    case actionTypes.GET_CLIENTS_FAILURE:
    case actionTypes.UPDATE_CLIENT_FAILURE:
    case actionTypes.DELETE_CLIENT_FAILURE:
    case actionTypes.MULTIDELETE_UNIT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default clientReducer
